/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Insurance_DocumentInputs */

const en_case_doc_insurance_document = /** @type {(inputs: Case_Doc_Insurance_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insurance document (if claim filed)`)
};

const pt_br2_case_doc_insurance_document = /** @type {(inputs: Case_Doc_Insurance_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento do seguro (se acionado)`)
};

/**
* | output |
* | --- |
* | "Insurance document (if claim filed)" |
*
* @param {Case_Doc_Insurance_DocumentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_insurance_document = /** @type {((inputs?: Case_Doc_Insurance_DocumentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Insurance_DocumentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_insurance_document(inputs)
	return pt_br2_case_doc_insurance_document(inputs)
});